/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HealthMetric
 */
export interface HealthMetric {
    /**
     * 
     * @type {string}
     * @memberof HealthMetric
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof HealthMetric
     */
    value: string;
}

/**
 * Check if a given object implements the HealthMetric interface.
 */
export function instanceOfHealthMetric(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "value" in value;

    return isInstance;
}

export function HealthMetricFromJSON(json: any): HealthMetric {
    return HealthMetricFromJSONTyped(json, false);
}

export function HealthMetricFromJSONTyped(json: any, ignoreDiscriminator: boolean): HealthMetric {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'value': json['value'],
    };
}

export function HealthMetricToJSON(value?: HealthMetric | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'value': value.value,
    };
}

